var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',[_c('h1',{staticClass:"is-bolder font-lg"},[_vm._v(" Olá"+_vm._s(_vm.firstName ? `, ${_vm.firstName}` : '')+"! ")]),_c('small',[_vm._v(" Aqui está o essencial para o seu dia. ")])]),(_vm.hasForm)?[_c(_vm.componentForm.component,{tag:"component"})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }